import { SearchBarBaseProps } from '@rneui/base/dist/SearchBar/types'
import { SearchBar as _SearchBar, makeStyles } from '@rneui/themed'
import React from 'react'

// WORKAROUND for React Native Elements 3.4.2 https://github.com/@rneui/themed/@rneui/themed/issues/3089#issuecomment-864570123
const SearchBar = _SearchBar as unknown as React.FC<SearchBarBaseProps>

interface Props {
  searchText: string
  setSearchText: (searchText: string) => void
  isLoading?: boolean
  autoFocus?: boolean
}

export function RecipientSearchBar({
  searchText,
  setSearchText,
  isLoading,
  autoFocus,
}: Props) {
  const styles = useStyles()
  return (
    <SearchBar
      placeholder="Search"
      onChangeText={setSearchText}
      value={searchText}
      containerStyle={styles.container}
      inputContainerStyle={styles.inputContainer}
      showLoading={isLoading}
      loadingProps={styles.loading}
      autoFocus={autoFocus}
    />
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.colors?.grey4,
    padding: 0,
    marginBottom: 10,
    borderBottomWidth: 0,
    borderTopWidth: 0,
  },
  inputContainer: {
    backgroundColor: theme.colors?.white,
  },
  loading: {
    color: theme.colors.primary,
  },
}))
